import React, { useState, useMemo } from 'react';
import { SpreadsheetTable } from './SpreadsheetTable';
import { resolveSheets, buildGrid } from '../utils/worksheetUtils';
import './WorksheetViewer.css';

interface WorksheetViewerProps {
  rawWorksheetData: Record<string, Record<string, any>>;
}

export const WorksheetViewer: React.FC<WorksheetViewerProps> = ({ rawWorksheetData }) => {
  const resolved = useMemo(() => resolveSheets(rawWorksheetData), [rawWorksheetData]);
  const sheetNames = useMemo(() => Object.keys(resolved), [resolved]);
  const [activeSheet, setActiveSheet] = useState(sheetNames[0] ?? '');

  const cells = resolved[activeSheet] ?? {};

  const { headers, rows, rowClasses } = useMemo(() => buildGrid(cells), [cells]);

  if (sheetNames.length === 0) {
    return <div className="ws-empty">No worksheet data available.</div>;
  }

  return (
    <div className="ws-outer">
      {sheetNames.length > 1 && (
        <div className="ws-sheet-tabs">
          {sheetNames.map(name => (
            <button
              key={name}
              className={`ws-sheet-tab ${activeSheet === name ? 'active' : ''}`}
              onClick={() => setActiveSheet(name)}
            >
              {name}
            </button>
          ))}
        </div>
      )}
      <SpreadsheetTable
        headers={headers}
        rows={rows}
        rowClasses={rowClasses}
      />
    </div>
  );
};
